<template>
	<v-card>
		<v-toolbar flat color="dark" dark>
			<v-toolbar-title>
				<span class="pl-2" v-if="id > 0">Edit Exam</span>
				<span class="pl-2" v-else>Add Exam</span>
			</v-toolbar-title>
		</v-toolbar>
		<v-card-text>
			<v-form>
				<v-row>
					
					<v-col cols="12" sm="6">
						<!-- <p class="font-weight-black title" >School info</p> -->
						<v-select
							dense
							:items="schoolyears"
							item-text="name"
							item-value="id"
							v-model="form.schoolyear_id"
							filled
							label="Schoolyear"
						></v-select>
						<v-select
							dense
							:items="sectors"
							item-text="name"
							item-value="id"
							v-model="form.sector_id"
							filled
							label="Sector"
						></v-select>
						<v-select
							dense
							:items="studys"
							item-text="name"
							item-value="id"
							v-model="form.study_id"
							filled
							label="Opleiding"
						></v-select>
						<v-select
							dense
							:items="classs"
							item-text="name"
							item-value="id"
							v-model="form.class_id"
							filled
							label="Klas"
						></v-select>
						<v-select
							dense
							:items="periodes"
							item-text="name"
							item-value="id"
							v-model="form.periode_id"
							filled
							label="Periode"
						></v-select>
						<v-select
							dense
							:items="employees"
							item-text="tbl_employee.teacher_name"
							item-value="employee_id"
							v-model="form.employee_id"
							filled
							label="Docent"
						></v-select>
						<v-select
							dense
							:items="subjects"
							item-text="tbl_sys_subject.name"
							item-value="subject_id"
							v-model="form.subject_id"
							filled
							label="Deelkwalificatie"
						></v-select>
							<v-select
							dense
							:items="modules"
							item-text="module"
							item-value="id"
							v-model="form.teacher_subject_class_id"
							filled
							label="Module"
						></v-select>
						<v-select
							dense
							:items="exam_types"
							item-text="name"
							item-value="id"
							v-model="form.exam_type_id"
							filled
							label="Toets type"
						></v-select>
						<v-select
							dense
							:items="locations"
							item-text="name"
							item-value="id"
							v-model="form.location_id"
							filled
							label="Plaats afname"
						></v-select>
						<v-text-field dense v-model="form.exam_description" :label="'Exam description'" filled>
									</v-text-field>
						<v-menu ref="menu_exam_date" v-model="menu_exam_date"
								:close-on-content-click="false" :return-value.sync="form.exam_date"
								transition="scale-transition" offset-y min-width="290px">
										<template v-slot:activator="{ on }">
											<v-text-field v-model="form.exam_date" label="Toetsdag*"
												prepend-inner-icon="mdi-calendar" readonly v-on="on" filled>
											</v-text-field>
										</template>
										<v-date-picker v-model="form.exam_date" no-title scrollable>
											<v-spacer></v-spacer>
											<v-btn text color="primary" @click="menu_exam_date = false">Cancel</v-btn>
											<v-btn text color="primary"
												@click="$refs.menu_exam_date.save(form.exam_date)">
												OK
											</v-btn>
										</v-date-picker>
									</v-menu>
						<v-text-field dense v-model="form.exam_time" label="Exam time" filled>
									</v-text-field>
						<v-text-field dense v-model="form.exam_proctor" label="Toezichthouder" filled>
									</v-text-field>
					</v-col> 
				</v-row>
			</v-form>
		</v-card-text>
		<v-card-actions>
			<v-btn color="primary" @click="submitForm(id)" depressed>Save</v-btn>
			<v-btn color="dark" @click="$router.go(-1);" depressed>Cancel</v-btn>
		</v-card-actions>

		<v-snackbar v-model="snackbar" bottom color="red" right :timeout="10000" top>
			Schooljaar en Klas van het student zijn niet geselecteerd! Ga naar de het tab "Klas" om deze in te stellen!
			<v-btn dark text @click="snackbar = false">Close</v-btn>
		</v-snackbar>
	</v-card>
</template>
 
 <script>
import Axios from "axios";
//import _ from "lodash";
// import moment from "moment";
import { API_ROOT } from "../../config";
console.log(API_ROOT.osbod_salary);
const ax = Axios.create({
	baseURL: API_ROOT["osbod_salary"],
	timeout: 60000
});

export default {
	name: "mutationedit",
	props: ["id"],
	data() {
		return {
			user: localStorage.getItem("user"),
			snackbar: false,
			sectors:[],
			classs:[],
			studys:[],
			subjects:[],
			modules:[],
			periodes:[],
			employees:[],
			schoolyears: [],
			exam_types: [],
			locations: [],
			menu_exam_date: false,
			users:[],
			form: {
				id: 0,
				schoolyear_id: null,
				sector_id: null,
				study_id: null,
				class_id: null,
				periode_id: null,
				employee_id:null,
				subject_id:null,
				teacher_subject_class_id:null,
				exam_type_id:null,
				location_id:null,
				exam_description:"",
				exam_date:"",
				exam_time:"",
				exam_proctor:""
			}
		};
	},
	created: function() {
		this.getUsers();
		this.getsectors();
		this.getPeriode();
		this.getEmployee();
		this.getSchoolyears();
		this.getExamTypes();
		this.getLocations();
		if (this.id > 0) {
				this.getExam(this.id);
				
			}
	},
	watch: {
		"form.sector_id": function(value){
				this.getStudy(value);
				// this.getClass1(value);
				
			},
		"form.study_id": function(value){
				this.getClass(value);
				// this.getClass1(value);
				
			},
		"form.periode_id": function(value){
				this.getEmployee(value);
				// this.getClass1(value);
				
			},
		"form.employee_id": function(value){
				this.getSubject(value);
				// this.getClass1(value);
			},
		"form.subject_id": function(value){
				this.getModule(value);
				// this.getClass1(value);
			},
	},
	methods: {
		Formatter: function(test) {
			console.log(test);

			return test;
		},
		getsectors: function() {
			var self = this;

			ax.get("/sector/all").then(function(response) {
				console.log(response.data);
				self.sectors = response.data;
			});
		},
		getStudy: function() {
			var self = this;

			ax.get("/study/selected_sector/", {
				params: {
					sector_id: self.form.sector_id,
				}
			}).then(function(response) {
				self.studys = response.data;
				console.log("After Fill");
	
			});
			
			
		},getSchoolyears: function () {
				var self = this;

				ax.get("/schoolyear/all_cursus").then(function (response) {
					console.log(response.data);
					self.schoolyears = response.data;
				});
			},
		getSubject: function() {
			var self = this;
			
			ax.get("/teacher_subject_class/all_exam_teacher_subject_cursus/", {
				params: {
					class_id: self.form.class_id,
					periode_id: self.form.periode_id,
					employee_id: self.form.employee_id,
				}
			}).then(function(response) {
				console.log("Subject Before Fill")
				console.log(self.subjects)
				self.subjects = response.data;
				console.log("Subject After Fill")
				console.log(self.subjects)
			});
			
		},
		getModule: function() {
			var self = this;
			
			ax.get("/teacher_subject_class/all_exam_teacher_module_cursus/", {
				params: {
					class_id: self.form.class_id,
					periode_id: self.form.periode_id,
					employee_id: self.form.employee_id,
					subject_id: self.form.subject_id,
				}
			}).then(function(response) {
				console.log("Modules Before Fill")
				console.log(self.modules)
				self.modules = response.data;
				console.log("Modules After Fill")
				console.log(self.modules)
			});
			
		},
		getExam: function (id) {
				var self = this;

				this.loading = true;
				ax.get("/exam/single/" + id).then(function (response) {
					console.log("I do what i am told");
					self.form = response.data;
					self.loading = false;
					console.log(response.data);
				});
			},
		getClass: function() {
			var self = this;

			ax.get("/school_class/selected_study/", {
				params: {
					study_id: self.form.study_id,
				}
			}).then(function(response) {
				console.log("Before Fill")
				console.log(self.classs)
				self.classs = response.data;
				console.log("After Fill")
				console.log(self.classs)
			});
			
		
		},
		getPeriode: function() {
			var self = this;

			ax.get("/periode/all").then(function(response) {
				console.log("Periode Fill")
				console.log(response.data);
				self.periodes = response.data;
			});
		},
		getUsers: function() {
			var self = this;

			ax.get("/users/all").then(function(response) {
				// console.log(response.data);
				self.users = response.data;
			});
		},
		getExamTypes: function() {
			var self = this;

			ax.get("/exam_type/all").then(function(response) {
				console.log("Periode Fill")
				console.log(response.data);
				self.exam_types = response.data;
			});
		},
		getLocations: function() {
			var self = this;

			ax.get("/location/all").then(function(response) {
				console.log("Location Fill")
				console.log(response.data);
				self.locations = response.data;
			});
		},
		getEmployee: function() {
			// var self = this;

			// ax.get("/employee/teacher_all").then(function(response) {
			// 	// console.log(response.data);
			// 	self.employees = response.data;
				

			// });
			var self = this;
			
			ax.get("/teacher_subject_class/all_exam_teacher_cursus/", {
				params: {
					class_id: self.form.class_id,
					periode_id: self.form.periode_id
				}
			}).then(function(response) {
				console.log("Subject Before Fill")
				console.log(self.employees)
				self.employees = response.data;
				console.log("Subject After Fill")
				console.log(self.employees)
			});
		},
		submitForm() {
			var self = this;
			self.form.subject_module = self.subjects.name;

			//this.$nextTick(function() {
			if (this.form.id > 0) {
				ax.post("/exam/update/" + this.form.id, this.form).then(function(
					response
				) {
					console.log(response.data);

					console.log("Mutations update...");

					self.$router.push({
						path: "/schooladmin/examcursus"
					});
				});
			} else {
				ax.post("/exam/create", this.form).then(function(response) {
					console.log(response.data);
					self.$router.push({
						path: "/schooladmin/examcursus"
					});
					console.log("Mutations created...");
				});
			}
			//});
		}
	}
};
</script>
